import * as React from 'react';
import { UnderDevelopment } from '../../../../../components';
import { UnscrollableContainer } from '../../../../../misc';

/**
 * Dashboard
 *
 * Admin dashboard page.
 * Currently under development.
 *
 * Features to consider for this page:
 * - Overview statistics (total students, staff, invigilators, sessions, etc.)
 * - Recent activity logs or notifications
 * - Quick links to manage users, allocations, attendance, and settings
 * - Charts/graphs for exam allocations, attendance rates, or room usage
 * - System health/status indicators
 * - Export and reporting tools
 * - Search and filter functionality for all records
 * - User management (add/edit/remove users)
 * - Upcoming events or deadlines
 */
export const Dashboard = (): JSX.Element => {
  return (
    <UnscrollableContainer className="flex flex-col justify-center items-center">
      <UnderDevelopment />
    </UnscrollableContainer>
  );
};
